import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnChanges, OnInit, QueryList, SimpleChanges, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiCalendarComponent } from '@components/ui-calendar/ui-calendar.component';
import { UiSettingForm } from '@components/ui-forms/ui-setting-form';
import { FeatureFlag, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { FileSizePipe } from '@pipes/file-size.pipe';
import { FileUploadService, ICSVParseErrorCode, ICSVParseErrorType, ModalService, } from '@services';
import { CalendarService } from '@services/calendar.service';
import { SUPPORTED_DATE_FORMATS } from '@services/generics/constants';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import * as moment from 'moment';
import { BehaviorSubject, iif, of, throwError, } from 'rxjs';
import { filter, finalize, map, switchMap, tap, } from 'rxjs/operators';
var MAX_FILE_SIZE = 128 * 1024;
var UiSkippedDaysSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiSkippedDaysSettingsComponent, _super);
    function UiSkippedDaysSettingsComponent(cd, appState, _fb, _modalService, _translateService, _fileUploadService, _fileSizePipe, _calendarService, _snack) {
        var _this = _super.call(this, cd, appState) || this;
        _this._fb = _fb;
        _this._modalService = _modalService;
        _this._translateService = _translateService;
        _this._fileUploadService = _fileUploadService;
        _this._fileSizePipe = _fileSizePipe;
        _this._calendarService = _calendarService;
        _this._snack = _snack;
        _this.selected = 0;
        _this.calendarsChange = new EventEmitter();
        _this.selectionChange = new EventEmitter();
        _this.creatingEntry = new EventEmitter();
        _this.isMultipleCalendarsEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.MultipleNonWorkingCalendars);
        _this.today = moment();
        _this.loading$ = new BehaviorSubject(false);
        _this.loadingFile$ = new BehaviorSubject(false);
        _this._showInvalidNameError = function () {
            _this._snack.error(_this._translateService.instant('skipped_days_duplicate_error'));
            _this.selectedCalendarItem.formGroup.get('name').setErrors({
                notUnique: true,
            });
        };
        return _this;
    }
    Object.defineProperty(UiSkippedDaysSettingsComponent.prototype, "dateFormatTooltip", {
        get: function () {
            return this._translateService.instant('skipped_days_csv_date_format') + '\r\n' +
                SUPPORTED_DATE_FORMATS.slice(0, 3).join('\r\n');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSkippedDaysSettingsComponent.prototype, "calendarPermissions", {
        get: function () {
            return this.selectedCalendar && this.selectedCalendar.newEntry ? 'Settings.Create' : 'Settings.Edit';
        },
        enumerable: true,
        configurable: true
    });
    UiSkippedDaysSettingsComponent.prototype.ngOnInit = function () {
        var calendarsInitialized = this.calendars && this.calendars.length > this.selected;
        var dates = calendarsInitialized ? this.calendars[this.selected].excludedDates : [];
        this.formGroup = this._fb.group({
            'date': [dates],
        });
        if (calendarsInitialized) {
            this.selectedCalendar = this.calendars[this.selected];
            this._loadCalendarDetail(this.selected);
        }
    };
    UiSkippedDaysSettingsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.selectedCalendarItem = this.calendarItems && this.calendarItems.find(function (_, idx) { return idx === _this.selected; });
    };
    UiSkippedDaysSettingsComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.dates && changes.dates.currentValue) {
            this.formGroup.patchValue({ date: changes.dates.currentValue });
        }
    };
    UiSkippedDaysSettingsComponent.prototype.createCalendarEntry = function () {
        // Add a new empty entry, to create dummy calendar
        this.calendars.unshift({
            calendarName: '',
            excludedDates: [],
            newEntry: true,
        });
        // Switch active calendar to newly created entry and focus input
        this._cd.detectChanges();
        this._changeSelected(0);
        this.creatingEntry.emit(true);
    };
    UiSkippedDaysSettingsComponent.prototype.onSelect = function (index) {
        var _this = this;
        if (this.selected !== index) {
            if (this.formGroup.dirty) {
                this._modalService.onConfirm(null, function () {
                    _this.formGroup.reset();
                    _this._changeSelected(index);
                }, function () { }, this._translateService.instant('skipped_days_calendar_unsaved_changes_warning'));
            }
            else {
                this._changeSelected(index);
            }
        }
    };
    UiSkippedDaysSettingsComponent.prototype.onDelete = function () {
        var _this = this;
        this._modalService.onConfirm(null, function () {
            if (_this.selectedCalendar && _this.selectedCalendar.newEntry) {
                _this._setCalendar([]);
                _this.selectedCalendarItem.formControl.reset();
                _this.calendars.shift();
                _this.creatingEntry.emit(false);
                if (_this.calendars.length) {
                    _this._changeSelected(0);
                }
                return;
            }
            var previouslySelected = _this.selected;
            _this._calendarService.delete(_this.selectedCalendar.calendarId)
                .pipe(tap(function () {
                if (_this.calendars && _this.calendars.length > 0) {
                    _this.selected = --_this.selected >= 0 ? _this.selected : 0;
                }
            }), finalize(function () {
                _this.formGroup.markAsPristine();
                _this._cd.detectChanges();
            }))
                .subscribe(function () {
                _this.calendars.splice(previouslySelected, 1);
                _this._changeSelected(_this.selected);
            });
        }, function () { }, this._translateService.instant('skipped_days_calendar_delete_warning'));
    };
    UiSkippedDaysSettingsComponent.prototype.onSave = function (calendar) {
        var _this = this;
        if (!this.selectedCalendarItem.formControl.dirty && !this.formGroup.get('date').dirty) {
            return;
        }
        this.loading$.next(true);
        if (this.formGroup.get('date').dirty) {
            calendar.excludedDates = this.formGroup.get('date')
                .value
                .map(function (d) { return moment(d).toDate(); });
        }
        calendar.calendarName = this.selectedCalendarItem && this.selectedCalendarItem.formControl.value.trim();
        var createOrUpdateCalendar$ = calendar.newEntry ?
            this._calendarService.add(calendar) :
            this._calendarService.updateAndMap(calendar.calendarId, calendar);
        iif(function () { return _this.selectedCalendarItem.formControl.dirty; }, this._calendarService.isCalendarNameValid(calendar.calendarName), of(true)).pipe(switchMap(function () { return createOrUpdateCalendar$; }), finalize(function () {
            _this.loading$.next(false);
            _this._cd.detectChanges();
        }), filter(function (savedCalendar) { return !!savedCalendar; })).subscribe(function (savedCalendar) {
            Object.assign(calendar, savedCalendar);
            _this.formGroup.get('date').reset(calendar.excludedDates);
            _this.selectedCalendarItem.formControl.reset(calendar.calendarName);
            delete calendar.newEntry;
            _this.calendarComponent.goToDate(moment());
            _this.creatingEntry.emit(false);
        }, this._showInvalidNameError);
    };
    UiSkippedDaysSettingsComponent.prototype.onFileChange = function (files) {
        var _this = this;
        if (!this._fileUploadService.isFileItemValid(files[0], ['.csv'], MAX_FILE_SIZE)) {
            this._snack.error(this._translateService.instant("file_size_too_large", {
                maxSize: this._fileSizePipe.transform(MAX_FILE_SIZE, 0),
            }));
        }
        var parseFile$ = this._calendarService.parseFile(files[0])
            .pipe(tap(function (csv) {
            _this.loadingFile$.next(true);
            csv.errors = csv.errors.filter(function (err) { return err.code !== ICSVParseErrorCode.UndetectableDelimiter; });
            if (csv.errors && csv.errors.length > 0) {
                var errorReason = (function (errorType) {
                    switch (errorType) {
                        case ICSVParseErrorType.FieldMismatch:
                            return _this._translateService.instant('csv_parser_error_field_mismatch');
                        case ICSVParseErrorType.FieldError:
                            return _this._translateService.instant('csv_parser_error_incorrect_date_format');
                    }
                })(csv.errors[0].type);
                _this._snack.error(_this._translateService.instant('skipped_days_calendar_csv_errors', {
                    reason: errorReason,
                }));
                throwError(csv.errors);
            }
        }), map(function (csv) {
            return csv.data
                .filter(function (date) { return date.excludedDate; })
                .map(function (date) { return moment(date.excludedDate).utc(true); });
        }), tap(function (data) {
            _this._setCalendar(data);
            _this.formGroup.get('date').markAsDirty();
        }), finalize(function () { return _this.loadingFile$.next(false); }));
        if (this.calendars[this.selected].excludedDates.length) {
            this._modalService.onConfirm(null, function () { return parseFile$.subscribe(); }, function () { }, this._translateService.instant('skipped_days_calendar_csv_confirm_override'));
        }
        else {
            parseFile$.subscribe();
        }
    };
    UiSkippedDaysSettingsComponent.prototype.onEscape = function () {
        var _this = this;
        if (this.calendars.some(function (cal) { return !!cal.newEntry; }) || this.formGroup.get('date').dirty) {
            this._modalService.onConfirm(null, function () { return _this._reset(); }, function () { }, this._translateService.instant('skipped_days_clear_unadded_warning'));
        }
    };
    UiSkippedDaysSettingsComponent.prototype.trackById = function (calendar) {
        return calendar.calendarId;
    };
    UiSkippedDaysSettingsComponent.prototype._changeSelected = function (index) {
        this.selected = index;
        this.selectedCalendarItem = this.calendarItems.find(function (_, idx) { return idx === index; });
        this.selectedCalendar = this.calendars[this.selected];
        this.calendarComponent.goToDate(moment());
        if (this.selectedCalendar && this.selectedCalendar.calendarId) {
            this.selectionChange.emit(index);
            this._loadCalendarDetail(index);
        }
        else {
            this._setCalendar([]);
        }
    };
    UiSkippedDaysSettingsComponent.prototype._loadCalendarDetail = function (index) {
        var _this = this;
        if (!this.calendars || !this.calendars[index]) {
            return;
        }
        this._setCalendar([]);
        var currentlySelectedCalendar = this.calendars[index];
        if (currentlySelectedCalendar.loading == null) {
            currentlySelectedCalendar.loading = true;
            this.loading$.next(true);
            this._calendarService.getInstance(currentlySelectedCalendar.calendarId)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function (calendar) {
                // This prevents calendar details from being loaded if the selection is changed before the data comes in
                currentlySelectedCalendar.calendarId = calendar.calendarId;
                currentlySelectedCalendar.timeZoneId = calendar.timeZoneId;
                currentlySelectedCalendar.excludedDates = calendar.excludedDates;
                _this._setCalendar(currentlySelectedCalendar.excludedDates);
                currentlySelectedCalendar.loading = false;
            }, function () { return delete currentlySelectedCalendar.loading; });
        }
        else {
            this._setCalendar(currentlySelectedCalendar.excludedDates);
        }
    };
    UiSkippedDaysSettingsComponent.prototype._setCalendar = function (dates) {
        this.formGroup.get('date').patchValue(dates);
    };
    UiSkippedDaysSettingsComponent.prototype._reset = function () {
        this.calendars = this.calendars.filter(function (cal) { return !cal.newEntry; });
        this.creatingEntry.emit(false);
        if (this.calendars && this.calendars.length) {
            this.formGroup.get('date').reset(this.selectedCalendar.excludedDates);
            this._changeSelected(0);
        }
        this._cd.detectChanges();
    };
    return UiSkippedDaysSettingsComponent;
}(UiSettingForm));
export { UiSkippedDaysSettingsComponent };
